import React from "react";
import PropTypes from "prop-types";
import UserRolesContext from "../../context/userRolesContext";

const WhenAuthorized = props => (
  <UserRolesContext.Consumer>
    {userRoles =>
      props.roles.every(r =>
        userRoles.map(_ => _.toLowerCase()).includes(r.toLowerCase())
      )
        ? props.children
        : props.fallback || null
    }
  </UserRolesContext.Consumer>
);

WhenAuthorized.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  fallback: PropTypes.object
};

export default WhenAuthorized;
